import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { pageNumberInfo } from '../../../redux/actions';

const PaginationResult = ({ resetPage, handleResetPageNo}) => {
  const dispatch = useDispatch()
  const [currentPage, setCurrentPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0)
  const pageNumber = useSelector((state) => state.paginationData.pageNumber);
  const tabNameInformation = useSelector((state) => state.paginationData.pagination)
  // const itemsPerPage = useSelector((state) => state.paginationData.dataInOnePage)
  const itemsPerPage = useSelector((state) => state.paginationData.dataInOnePageResult);
  const totalNumberOfResult = useSelector((state) => state.paginationData.totalNumberOfResult)

  // Calculate the total pages based on the updated filtered result count
  const totalPages = Math.ceil(totalNumberOfResult / itemsPerPage);

  // Update `totalPagesToShow` to only show necessary pages
  const totalPagesToShow = Math.min(5, totalPages); 

  useEffect(() => {
    if (resetPage) {
      dispatch(pageNumberInfo(1)); // Reset Redux state
    setCurrentPage(1);           // Reset local page
    handleResetPageNo();          // Call reset handler if needed
    }
  }, [resetPage, handleResetPageNo]);

  useEffect(() => {

    setTotalItems(totalNumberOfResult)

  }, [totalNumberOfResult])

  useEffect(() => {
    setCurrentPage(1)
  }, [tabNameInformation])


  useEffect(() => {
    dispatch(pageNumberInfo(currentPage))
  }, [currentPage])


  const goToPreviousPage = () => {
    // setCurrentPage(prevPage => Math.max(prevPage - 1, 1));
    const newPage = Math.max(currentPage - 1, 1);
    setCurrentPage(newPage);
  };

  const goToNextPage = () => {
    setCurrentPage(prevPage => Math.min(prevPage + 1, totalPages));
  };

  const firstPageNumber = Math.max(currentPage - Math.floor(totalPagesToShow / 2), 1);
  const lastPageNumber = Math.min(firstPageNumber + totalPagesToShow - 1, totalPages);

  const renderPageNumbers = () => {
    const pageNumbers = [];

    // Show only the current page if totalNumberOfResult is less than 30
    if (totalNumberOfResult < 30) {
      pageNumbers.push(
        <div key={currentPage} className={`pagination-number active`}>
          {currentPage}
        </div>
      );
    } else {
      // Otherwise, render the normal pagination based on the calculated range
      for (let i = firstPageNumber; i <= lastPageNumber; i++) {
        pageNumbers.push(
          <div key={i} className={`pagination-number ${currentPage === i ? 'active' : ''}`} onClick={() => setCurrentPage(i)}>
            {i}
          </div>
        );
      }
    }
    return pageNumbers;
  };
  return (
    <div className="pagination">
      {totalNumberOfResult > 0 && (
        <>
          <div
            className="pagination-arrow left-arrow"
            style={{ cursor: currentPage === 1 ? 'not-allowed' : 'pointer' }}
            onClick={goToPreviousPage}
          >
            &lt;&lt;
          </div>
          <div className="pagination-numbers">
            {renderPageNumbers()}
          </div>
          <div
            className="pagination-arrow right-arrow"
            style={{ cursor: currentPage === totalPages ? 'not-allowed' : 'pointer' }}
            onClick={goToNextPage}
          >
            &gt;&gt;
          </div>
        </>
      )}
    </div>
  );
};

export default PaginationResult;
